module.exports = __webpack_public_path__ + "img/new-staff-member.91559744.png";